module.exports = __webpack_public_path__ + "static/media/necolinehubner.513ac86e.png";